module.exports = __webpack_public_path__ + "static/media/COEP.f3ddcacf.png";